import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
  FormFeedback,
} from "reactstrap";
import * as yup from "yup";
import { useFormik } from "formik";

//Import Breadcrumb
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import { setAuthorization } from "../../helpers/api_helper";
import { useDispatch, useSelector } from "react-redux";
import { getInfoEntityLegalUser } from "../../helpers/dataBackend";
import { createSelector } from "reselect";

const CompanyData = () => {
  //meta title
  document.title = "Ditobanx | Company Data";

  const dispatch = useDispatch<any>();
  const [entityData, setEntityData] = useState<any>({});
  const [userData, setUserData] = useState<any>({});

  const selectProperties = createSelector(
    (state) => state.Login,
    (login) => ({
      isAdmin: login.isAdmin || false, // Validar si el usuario es admin
    })
  );

  const { isAdmin } = useSelector(selectProperties);

  //Meta Data Entity
  const metaDataEntity: any = useFormik({
    enableReinitialize: true, // esta linea nos permite hacerlo asincronico
    initialValues: {
      commercialname: "entityData.commercial_name",
      social_number: "entityData.social_number",
      nit: "entityData.numero_documento",
      email: "entityData.email",
      nrc: "entityData.nrc",
      enabled: "entityData.status_catalog.name",
      economic_activity: "entityData.economic_activity",
      created_at: "entityData.created_at",
    },
    validationSchema: yup.object().shape({
      commercialname: yup.string().required("Please Enter Your Product Name"),
    }),
    onSubmit: (values: any) => {
      // console.log('Meta Data', values);
      metaDataEntity.resetForm();
    },
  });

  //Meta Data User
  const metaDataUser: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: userData.name,
      lastname: userData.last_name,
      emailUser: userData.email,
      phone_number: userData.phone_number,
      document_number: userData.document_number,
      address: userData.address,
      company_position: userData.company_position,
    },
    validationSchema: yup.object().shape({
      name: yup.string().required("Please Enter Your Product Name"),
    }),
    onSubmit: (values: any) => {
      // console.log('Meta Data', values);
      metaDataEntity.resetForm();
    },
  });

  useEffect(() => {
    async function getData() {
      const token = localStorage.getItem("authUser");
      setAuthorization(token); // Guardar el token antes de continuar
      try {
        const response = await getInfoEntityLegalUser();
        console.log(response);
        setEntityData(response.entity);
        setUserData(response.user);
      } catch (error) {
        console.log("Error fetching user data", error);
      }
    }
    getData();
  }, [dispatch]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Company Data" breadcrumbItem="Company Data" />
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <CardTitle tag="h4">Informacion de la empresa</CardTitle>
                  <Form
                    onSubmit={metaDataEntity.handleSubmit}
                    autoComplete="off"
                    className="mt-3"
                  >
                    <Row>
                      <Col sm="6">
                        <div className="mb-3">
                          <Label htmlFor="commercialname">
                            Nombre Comercial
                          </Label>
                          <Input
                            id="commercialname"
                            name="commercialname"
                            type="text"
                            placeholder="commercial name"
                            value={metaDataEntity.values.commercialname || ""}
                            onChange={metaDataEntity.handleChange}
                            disabled
                            invalid={
                              metaDataEntity.touched.commercialname &&
                              metaDataEntity.errors.commercialname
                                ? true
                                : false
                            }
                          />
                          {metaDataEntity.errors.commercialname &&
                          metaDataEntity.touched.commercialname ? (
                            <FormFeedback type="invalid">
                              {metaDataEntity.errors.commercialname}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="social_number"> social_number </Label>
                          <Input
                            id="social_number"
                            name="social_number"
                            type="text"
                            placeholder="social_number"
                            value={metaDataEntity.values.social_number}
                            onChange={metaDataEntity.handleChange}
                            disabled
                            invalid={
                              metaDataEntity.touched.social_number &&
                              metaDataEntity.errors.social_number
                                ? true
                                : false
                            }
                          />
                          {metaDataEntity.errors.social_number &&
                          metaDataEntity.touched.social_number ? (
                            <FormFeedback type="invalid">
                              {metaDataEntity.errors.social_number}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="nit"> NIT </Label>
                          <Input
                            id="nit"
                            name="nit"
                            type="number"
                            placeholder="NIT"
                            value={metaDataEntity.values.nit}
                            onChange={metaDataEntity.nit}
                            disabled
                            invalid={
                              metaDataEntity.touched.nit &&
                              metaDataEntity.errors.nit
                                ? true
                                : false
                            }
                          />
                          {metaDataEntity.errors.nit &&
                          metaDataEntity.touched.nit ? (
                            <FormFeedback type="invalid">
                              {metaDataEntity.errors.nit}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="nrc">NRC</Label>
                          <Input
                            id="nrc"
                            name="nrc"
                            type="number"
                            placeholder="nrc"
                            value={metaDataEntity.values.nrc}
                            onChange={metaDataEntity.handleChange}
                            disabled
                            invalid={
                              metaDataEntity.touched.nrc &&
                              metaDataEntity.errors.nrc
                                ? true
                                : false
                            }
                          />
                          {metaDataEntity.errors.nrc &&
                          metaDataEntity.touched.nrc ? (
                            <FormFeedback type="invalid">
                              {metaDataEntity.errors.nrc}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>

                      <Col sm="6">
                        <div className="mb-3">
                          <Label htmlFor="email">email Entity</Label>
                          <Input
                            id="email"
                            name="email"
                            type="text"
                            placeholder="emailEntity"
                            value={metaDataEntity.values.email}
                            onChange={metaDataEntity.handleChange}
                            disabled
                            invalid={
                              metaDataEntity.touched.email &&
                              metaDataEntity.errors.email
                                ? true
                                : false
                            }
                          />
                          {metaDataEntity.errors.email &&
                          metaDataEntity.touched.email ? (
                            <FormFeedback type="invalid">
                              {metaDataEntity.errors.email}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="enabled"> enabled </Label>
                          <Input
                            id="enabled"
                            name="enabled"
                            type="text"
                            placeholder="Enabled"
                            value={metaDataEntity.values.enabled}
                            onChange={metaDataEntity.handleChange}
                            disabled
                            invalid={
                              metaDataEntity.touched.enabled &&
                              metaDataEntity.errors.enabled
                                ? true
                                : false
                            }
                          />
                          {metaDataEntity.errors.enabled &&
                          metaDataEntity.touched.enabled ? (
                            <FormFeedback type="invalid">
                              {metaDataEntity.errors.enabled}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="economic_activity">
                            {" "}
                            Actividad Economica{" "}
                          </Label>
                          <Input
                            id="economic_activity"
                            name="economic_activity"
                            type="text"
                            placeholder="Actividad economica"
                            value={metaDataEntity.values.economic_activity}
                            onChange={metaDataEntity.economic_activity}
                            disabled
                            invalid={
                              metaDataEntity.touched.economic_activity &&
                              metaDataEntity.errors.economic_activity
                                ? true
                                : false
                            }
                          />
                          {metaDataEntity.errors.economic_activity &&
                          metaDataEntity.touched.economic_activity ? (
                            <FormFeedback type="invalid">
                              {metaDataEntity.errors.economic_activity}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="created_at">Creado en</Label>
                          <Input
                            id="created_at"
                            name="created_at"
                            type="text"
                            placeholder="created_at"
                            value={metaDataEntity.values.created_at}
                            onChange={metaDataEntity.handleChange}
                            disabled
                            invalid={
                              metaDataEntity.touched.created_at &&
                              metaDataEntity.errors.created_at
                                ? true
                                : false
                            }
                          />
                          {metaDataEntity.errors.created_at &&
                          metaDataEntity.touched.created_at ? (
                            <FormFeedback type="invalid">
                              {metaDataEntity.errors.created_at}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    {/* Si posee rol de admin podra editar la informacion */}
                    {isAdmin ? (
                      <div className="d-flex flex-wrap gap-2">
                        <Button type="submit" color="primary">
                          {" "}
                          Save Changes{" "}
                        </Button>
                        <Button
                          type="button"
                          color="secondary"
                          onClick={() => metaDataEntity.resetForm()}
                        >
                          {" "}
                          Cancel
                        </Button>
                      </div>
                    ) : null}
                  </Form>
                </CardBody>
              </Card>

              {/* REPRESENTANTE LEGAL DE LA ENTIDAD */}
              <Card>
                <CardBody>
                  <CardTitle tag="h4">
                    Informacion Representante Legal
                  </CardTitle>
                  <Form
                    onSubmit={metaDataUser.handleSubmit}
                    autoComplete="off"
                    className="mt-3"
                  >
                    <Row>
                      <Col sm="6">
                        <div className="mb-3">
                          <Label htmlFor="name">Nombre</Label>
                          <Input
                            id="name"
                            name="name"
                            type="text"
                            placeholder="Nombre"
                            value={metaDataUser.values.name || ""}
                            onChange={metaDataUser.handleChange}
                            disabled
                            invalid={
                              metaDataUser.touched.name &&
                              metaDataUser.errors.name
                                ? true
                                : false
                            }
                          />
                          {metaDataUser.errors.name &&
                          metaDataUser.touched.name ? (
                            <FormFeedback type="invalid">
                              {metaDataUser.errors.name}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="lastname">Apellido</Label>
                          <Input
                            id="lastname"
                            name="lastname"
                            type="text"
                            placeholder="Apellido"
                            value={metaDataUser.values.lastname}
                            onChange={metaDataUser.handleChange}
                            disabled
                            invalid={
                              metaDataUser.touched.lastname &&
                              metaDataUser.errors.lastname
                                ? true
                                : false
                            }
                          />
                          {metaDataUser.errors.lastname &&
                          metaDataUser.touched.lastname ? (
                            <FormFeedback type="invalid">
                              {metaDataUser.errors.lastname}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="emailUser">Correo electronico</Label>
                          <Input
                            id="emailUser"
                            name="emailUser"
                            type="text"
                            placeholder="Email"
                            value={metaDataUser.values.emailUser}
                            onChange={metaDataUser.handleChange}
                            disabled
                            invalid={
                              metaDataUser.touched.emailUser &&
                              metaDataUser.errors.emailUser
                                ? true
                                : false
                            }
                          />
                          {metaDataUser.errors.emailUser &&
                          metaDataUser.touched.emailUser ? (
                            <FormFeedback type="invalid">
                              {metaDataUser.errors.emailUser}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="phone_number">Telefono</Label>
                          <Input
                            id="phone_number"
                            name="phone_number"
                            type="number"
                            placeholder="phone_number"
                            value={metaDataUser.values.phone_number}
                            onChange={metaDataUser.handleChange}
                            disabled
                            invalid={
                              metaDataUser.touched.phone_number &&
                              metaDataUser.errors.phone_number
                                ? true
                                : false
                            }
                          />
                          {metaDataUser.errors.phone_number &&
                          metaDataUser.touched.phone_number ? (
                            <FormFeedback type="invalid">
                              {metaDataUser.errors.phone_number}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>

                      <Col sm="6">
                        <div className="mb-3">
                          <Label htmlFor="document_number">Documento</Label>
                          <Input
                            id="document_number"
                            name="document_number"
                            type="number"
                            placeholder="document_number"
                            value={metaDataUser.values.document_number}
                            onChange={metaDataUser.handleChange}
                            disabled
                            invalid={
                              metaDataUser.touched.document_number &&
                              metaDataUser.errors.document_number
                                ? true
                                : false
                            }
                          />
                          {metaDataUser.errors.document_number &&
                          metaDataUser.touched.document_number ? (
                            <FormFeedback type="invalid">
                              {metaDataUser.errors.document_number}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="address">Direccion</Label>
                          <Input
                            id="address"
                            name="address"
                            type="text"
                            placeholder="address"
                            value={metaDataUser.values.address}
                            onChange={metaDataUser.handleChange}
                            disabled
                            invalid={
                              metaDataUser.touched.address &&
                              metaDataUser.errors.address
                                ? true
                                : false
                            }
                          />
                          {metaDataUser.errors.address &&
                          metaDataUser.touched.address ? (
                            <FormFeedback type="invalid">
                              {metaDataUser.errors.address}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="company_position">Posicion</Label>
                          <Input
                            id="company_position"
                            name="company_position"
                            type="number"
                            placeholder="company_position"
                            value={metaDataUser.values.company_position}
                            onChange={metaDataUser.handleChange}
                            disabled
                            invalid={
                              metaDataUser.touched.company_position &&
                              metaDataUser.errors.company_position
                                ? true
                                : false
                            }
                          />
                          {metaDataUser.errors.company_position &&
                          metaDataUser.touched.company_position ? (
                            <FormFeedback type="invalid">
                              {metaDataUser.errors.company_position}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    {/* Si posee rol de admin podra editar la informacion */}
                    {isAdmin ? (
                      <div className="d-flex flex-wrap gap-2">
                        <Button type="submit" color="primary">
                          {" "}
                          Save Changes{" "}
                        </Button>
                        <Button
                          type="button"
                          color="secondary"
                          onClick={() => metaDataUser.resetForm()}
                        >
                          {" "}
                          Cancel
                        </Button>
                      </div>
                    ) : null}
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CompanyData;
